(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/shared/deposit/deposit-dialogs.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/shared/deposit/deposit-dialogs.js');

'use strict';

const formatCurrency = svs.utils.format.Currency;
const showDepositErrorDialog = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Kunde inte sätta in pengar till laget',
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showDepositBlockedUserDialog = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Spärrad kund',
    message: [{
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: 'Det gick inte att sätta in i laget eftersom ditt spelkonto är spärrat.'
    }, {
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: 'Har du några frågor? Kontakta Kundservice på <a href="tel:0770-111111">0770-11 11 11</a>.'
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showDepositInviteDialog = initialDeposit => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'deposit',
    title: "Lagledaren har rekommenderat en \xF6verf\xF6ring till lagkassan p\xE5 ".concat(formatCurrency(initialDeposit), " kr"),
    message: [{
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: 'Du för över pengar till lagkassan från ditt spelkonto. Har du inte pengar på ditt spelkonto behöver du först göra en insättning.'
    }],
    actions: [{
      title: 'Nej tack',
      callback: () => {
        dialog.close();
        resolve(false);
      }
    }, {
      title: "\xD6verf\xF6r ".concat(formatCurrency(initialDeposit), " kr"),
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showDepositCreateDialog = initialDeposit => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'deposit',
    title: "Vill du ocks\xE5 g\xF6ra en \xF6verf\xF6ring p\xE5 ".concat(formatCurrency(initialDeposit), " kr?"),
    message: [{
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: 'Du för över pengar till lagkassan från ditt spelkonto. Har du inte pengar på ditt spelkonto behöver du först göra en insättning.'
    }],
    actions: [{
      title: 'Nej tack',
      callback: () => {
        dialog.close();
        resolve(false);
      }
    }, {
      title: "\xD6verf\xF6r ".concat(formatCurrency(initialDeposit), " kr"),
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showBalanceTooLowDialog = balance => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'deposit',
    title: 'Du har inte tillräckligt med pengar',
    message: [{
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: 'Vill du sätta in pengar och föra över till laget?'
    }, {
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: "Ditt saldo: ".concat(formatCurrency(balance), " kr")
    }],
    actions: [{
      title: 'Nej, avbryt',
      callback: () => {
        dialog.close();
        resolve(false);
      }
    }, {
      title: 'Sätt in pengar',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showDepositDialog = amount => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'deposit',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    title: "Vill du f\xF6ra \xF6ver ".concat(amount, " kr till lagkontot?"),
    message: [{
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: 'Du för över från ditt spelkonto till lagkontot.'
    }],
    actions: [{
      title: 'Avbryt',
      callback: () => {
        dialog.close();
        resolve(false);
      }
    }, {
      title: 'Bekräfta',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showWithdrawalDialog = amount => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'deposit',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    title: "Vill du f\xF6ra \xF6ver ".concat(amount, " kr fr\xE5n lagkontot?"),
    message: [{
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: 'Pengarna förs över till ditt spelkonto'
    }],
    actions: [{
      title: 'Avbryt',
      callback: () => {
        dialog.close();
        resolve(false);
      }
    }, {
      title: 'Bekräfta',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showDepositOkDialog = amount => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'deposit',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    title: 'Överföringen genomförd',
    message: [{
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: "".concat(amount, " kr har flyttats till lagkontot.")
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showAfterPayOkDialog = (amount, balance) => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'deposit',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    title: 'Din insättning är klar.',
    message: [{
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: "Du har f\xF6rt \xF6ver ".concat(svs.utils.format.Currency(amount), " kr till laget.")
    }, {
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: "Ditt saldo p\xE5 spelkontot: ".concat(svs.utils.format.Currency(balance), " kr")
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showDepositLimitNotSet = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'deposit-limits',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    title: 'För att kunna föra över pengar till lagkontot behöver du sätta dina insättningsgränser',
    actions: [{
      title: 'Avbryt',
      callback: () => {
        dialog.close();
        resolve(false);
      }
    }, {
      title: 'Sätt gränser',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showWithdrawalOkDialog = (amount, teamName) => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'thumbs-up',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    title: 'Uttag genomfört',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: "<span class=\"f-bold\">".concat(amount, " kr</span> har \xF6verf\xF6rts fr\xE5n <span class=\"f-bold\">").concat(teamName, "</span> till ditt spelkonto."),
      align: svs.ui.dialog.message.align.CENTER
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showWithdrawalNotOkDialog = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Detta uttag är inte giltig',
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showWithdrawalLockedPlayerAccountDialog = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Spärrat konto',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Du kan inte genomföra uttaget eftersom ditt konto är spärrat.<br /> Har du några frågor? Kontakta Kundservice på <a href="tel:0770-111111">0770-11 11 11</a>.'
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
svs.arena.shared.deposit.depositDialogs = {
  showDepositDialog,
  showDepositOkDialog,
  showAfterPayOkDialog,
  showDepositLimitNotSet,
  showDepositInviteDialog,
  showDepositCreateDialog,
  showBalanceTooLowDialog,
  showDepositErrorDialog,
  showDepositBlockedUserDialog,
  showWithdrawalDialog,
  showWithdrawalOkDialog,
  showWithdrawalNotOkDialog,
  showWithdrawalLockedPlayerAccountDialog
};

 })(window);